import { gql } from "@apollo/client";

export const GET_CONSULTA_CIERRE_AGRUPADO = gql`
query consultaCierreAgrupado($mes: Int!, $anio: Int!) {
    consultaCierreAgrupado(mes: $mes, anio: $anio) { 
        valorEsperado{
            materialTipo
            cantidad
            total
        }
    }
}`;